import HRUpdateJob from "src/components/job/hr/UpdateJob";

export default function UpdateJob() {

  return (
    <div className="w-11/12 max-w-7xl mx-auto">
      <HRUpdateJob/>
    </div>
  )
}
